module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp123_8.9e1bf53f.png";